// removed by extract-text-webpack-plugin
module.exports = {"OpeningHours":"_342WXHUbsbon4I0LJ0x8zr","OpeningHours-Link":"_3HJce2CuZ8p862vn3L4gs5","OpeningHours_active":"_18wMHUm9oCLJ7JV3XrWiCB","OpeningHours-Overlay":"_1aAcf-8LqKAVzQap_8xwBJ","OpeningHours-Modal":"_3myfC39HhlFa_YnEExIAHB","OpeningHours-Content":"_2PRa9MHtPneqLrHjDkZBbk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Components/OpeningHours/OpeningHours.css
// module id = 267
// module chunks = 8